import { render } from "./DashboardWidgetRedzonesAlerts.vue?vue&type=template&id=118c0dce"
import script from "./DashboardWidgetRedzonesAlerts.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetRedzonesAlerts.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__